export const PUMA_APP_ID =  '75a6c3f9-14e5-44ef-bc98-62e2c08dd9f9';
export const PUMA_MODULE_NAME = 'DOLPHIN_RTS_';
